import { useState, useRef } from 'react'
import { MenuItem, Checkbox, ListItemText } from '@mui/material'
import { FilterListRounded } from '@mui/icons-material'
import SecondaryNavBar from '../../../components/SecondaryNavBar'
import LoadingScreen from '../../../components/LoadingScreen'
import { logError } from '../../../shared/logger'
import { useSpacesQuery } from '../../../shared/queryHooks'
import { useAuthContext } from '../../../context/AuthContext'
import { useOutsideAlerter } from '../../../shared/utilities'
import './index.css'
import { NavigationAction } from '../../../types'
import { useModal } from '../../../context/ModalContext'
import CreateOrEditSpace from '../../../modals/CreateOrEditSpace'
import { SpacesTable } from '../../../components/SpacesTable'

function WorkspaceSettingsSpaces () {
  const { currentUser } = useAuthContext()
  const { makeModal } = useModal()
  const [showArchived, setShowArchived] = useState(false)
  const [showFilterDropdown, setShowFilterDropdown] = useState(false)
  const filterRef = useRef(null)
  useOutsideAlerter({
    ref: filterRef,
    setDisplayState: setShowFilterDropdown
  })

  const orgId = currentUser?.currentOrganizationId ?? 0

  const {
    isLoading,
    isError,
    data: spaces,
    error
  } = useSpacesQuery(orgId, {
    enabled: !!currentUser,
    isArchived: 'all'
  })

  if (isLoading) {
    return (
      <>
        <SecondaryNavBar title="Spaces" />
        <LoadingScreen />
      </>
    )
  }

  if (isError) logError(error)

  const filteredSpaces = showArchived
    ? spaces?.filter(s => s.isArchived)
    : spaces?.filter(s => !s.isArchived)
  const sortedSpaces = filteredSpaces?.sort((a, b) => a.name.localeCompare(b.name))

  const actions: NavigationAction[] = [
    {
      action: () =>
        makeModal({
          modal: <CreateOrEditSpace openedFromAdmin />,
          title: 'New Space'
        }),
      actionTitle: 'New Space',
      actionClassName: 'secondary'
    }
  ]

  return (
    <>
      <SecondaryNavBar title="Spaces" onClickActions={actions} />
      <div className="org-nav-settings">
        <div className="spaces-filter-table-container">
          <div ref={filterRef} style={{ position: 'relative' }}>
            <div className="tag-filter-container">
              <div
                className="button transparent"
                onClick={() => setShowFilterDropdown(!showFilterDropdown)}
                style={{
                  padding: '0.25rem 0.5rem',
                  paddingRight: '0',
                  paddingLeft: '1rem'
                }}
              >
                <FilterListRounded />
                Filter{showArchived ? ' (1)' : ''}
              </div>
              {showArchived && (
                <div
                  className="button transparent"
                  onClick={() => setShowArchived(false)}
                  style={{ padding: '0.25rem 0.5rem' }}
                >
                  Clear Filter
                </div>
              )}
            </div>
            {showFilterDropdown && (
              <div className="tag-dropdown">
                <MenuItem
                  onClick={() => {
                    setShowArchived(!showArchived)
                    setShowFilterDropdown(false)
                  }}
                >
                  <Checkbox checked={showArchived} />
                  <ListItemText primary="Archived" />
                </MenuItem>
              </div>
            )}
          </div>
          <SpacesTable data={sortedSpaces ?? []} />
        </div>
      </div>
    </>
  )
}

export default WorkspaceSettingsSpaces
